/**
 * Single product page — AJAX add-to-cart that opens the side cart.
 *
 * WooCommerce's single-product form (`form.cart` + `.single_add_to_cart_button`)
 * is a plain POST that reloads the page. Intercept it, add via WooCommerce's
 * `wc-ajax=add_to_cart` endpoint, apply the returned fragments, and fire
 * `added_to_cart` so the drawer opens and the header badge updates — matching the
 * archive add-to-cart behaviour.
 *
 * Only simple products are handled; variable products (with a `variation_id`
 * field) and disabled buttons fall through to the native submit.
 */

const $ = (window as any).jQuery;

if ($) {
  $(function () {
    $(document.body).on("submit", "form.cart", function (this: HTMLFormElement, e: Event) {
      const $form = $(this);
      const $button = $form.find(".single_add_to_cart_button");
      const productId = $button.val();

      // Bail to the native submit for anything that isn't a plain simple-product add.
      if (
        !$button.length ||
        $button.is(".disabled") ||
        !productId ||
        $form.find("[name='variation_id']").length
      ) {
        return;
      }

      e.preventDefault();

      const quantity = $form.find("input.qty").val() || 1;
      $button.removeClass("added").addClass("loading");

      const data = new FormData();
      data.append("product_id", String(productId));
      data.append("quantity", String(quantity));

      // WooCommerce's localised endpoint carries the WPML language prefix
      // (`/en/?wc-ajax=…`). A bare `/?wc-ajax=` runs in the default language
      // while posting the translated product ID, and WCML's cross-language
      // re-keying then drops or splits the line instead of adding to it.
      const params = (window as any).wc_add_to_cart_params;
      const addToCartUrl = params?.wc_ajax_url
        ? String(params.wc_ajax_url).replace("%%endpoint%%", "add_to_cart")
        : "/?wc-ajax=add_to_cart";

      fetch(addToCartUrl, {
        method: "POST",
        body: data,
        credentials: "same-origin",
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res) return;

          // WooCommerce asks for a redirect (e.g. "AJAX add to cart" disabled) or errors out.
          if (res.error && res.product_url) {
            window.location.assign(res.product_url);
            return;
          }

          if (res.fragments) {
            Object.keys(res.fragments).forEach((key) => {
              $(key).replaceWith(res.fragments[key]);
            });
          }

          $button.removeClass("loading").addClass("added");
          // Namespaced rather than WooCommerce's own `added_to_cart`: core's
          // add-to-cart.js listens for that one and appends a "View cart" link
          // beside the button, which we do not want on the single product page.
          // Fragments are applied above, so nothing of core's handler is needed.
          // sideCart.ts / cartTooltip.ts both listen for this event.
          $(document.body).trigger("niamito_added_to_cart", [res.fragments, res.cart_hash, $button]);
        })
        .catch(() => {
          // Network/parse failure: fall back to a normal page-reload submit.
          $button.removeClass("loading");
          $form.off("submit");
          (this as HTMLFormElement).submit();
        });
    });
  });
}
